import { render, staticRenderFns } from "./FeatureCardZdmCabinet.vue?vue&type=template&id=847f3ab2&scoped=true&"
import script from "./FeatureCardZdmCabinet.vue?vue&type=script&lang=js&"
export * from "./FeatureCardZdmCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847f3ab2",
  null
  
)

export default component.exports